import React, { memo } from 'react';
import Anchor from '@wconcept/wconcept-ui/components/atoms/Anchor';
import ImgTitBanner from '@wconcept/wconcept-ui-renewal/src/components/molecules/_banner/ImgTitBanner';
import { IPlayAuthTokenConfig } from '@byteplus/veplayer';
import useLinkTo from '@hooks/useLinkTo';
import useGa4Event from '@hooks/useGa4Event';

interface BannerModuleProps {
  vid?: string;
  videoSrc?: string;
  videoPoster?: string;
  token?: IPlayAuthTokenConfig;
  imgSrc?: string;
  order: number;
  landingUrl?: string;
  gaInfo?: {
    cd?: number;
    nm?: string;
    page: string;
    area: string;
    text?: string;
  };
}

function BannerModule({
  vid,
  videoSrc,
  videoPoster,
  token,
  imgSrc,
  order,
  landingUrl,
  gaInfo,
}: BannerModuleProps) {
  const { linkTo } = useLinkTo();
  const { sendGa4BannerClick } = useGa4Event();

  return (
    <ImgTitBanner
      imgSrc={imgSrc}
      alt={gaInfo?.text}
      vid={vid}
      videoSrc={!token && videoSrc ? videoSrc : undefined}
      videoPoster={videoPoster}
      token={token || undefined}
      onClick={() => {
        sendGa4BannerClick({
          issueCd: gaInfo?.cd?.toString(),
          issueNm: gaInfo?.nm,
          page: gaInfo?.page,
          area: gaInfo?.area,
          text: gaInfo?.text,
        });
        if (landingUrl) {
          linkTo.push({
            url: landingUrl,
          });
        }
      }}
    />
  );
}

export default memo(BannerModule);
